import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取预产期天数信息列表 **/
    GET_BRAND_ALL(data) {
        controller='EsBrand';
        action='GetBrandAll';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取品牌信息列表 **/
    GET_BRAND_LIST(data) {
        controller='EsBrand';
        action='GetBrandList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增品牌 **/
    ADD_BRAND(data) {
        controller='EsBrand';
        action='AddBrand';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除品牌信息 **/
    DEL_BRAND(data) {
        controller='EsBrand';
        action='DelBrand';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取品牌信息 **/
    GET_BRAND_INFOS(data) {
        controller='EsBrand';
        action='GetBrandInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 更新品牌信息 **/
    UPDATE_BRAND(data) {
        controller='EsBrand';
        action='EditBrand';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

}